import { Link } from 'react-router-dom'

const Error403 = () => {
  return (
    <div className="page error-bg dark:!bg-bodybg" id="particles-js">
      <div className="error-page">
        <div className="container text-defaulttextcolor text-defaultsize">
          <div className="text-center p-5 my-auto">
            <div className="flex items-center justify-center h-full">
              <div className="xl:col-span-3"></div>
              <div className="xl:col-span-6 col-span-12">
                <p className="error-text sm:mb-0 mb-2">403</p>
                <p className="text-[1.125rem] font-semibold mb-4 dark:text-defaulttextcolor/70">Forbidden Access 😞</p>
                <div className="flex justify-center items-center mb-[3rem]">
                  <div className="xl:col-span-6 w-[50%]">
                    <p className="mb-0 opacity-[0.7]">
                      Sorry, you do not have permission to access this page. Please check your credentials or contact
                      the administrator if you believe this is a mistake.
                    </p>
                  </div>
                </div>
                <Link
                  to={`${import.meta.env.BASE_URL}dashboard`}
                  className="ti-btn bg-primary text-white font-semibold dark:border-defaultborder/10"
                >
                  <i className="ri-arrow-left-line align-middle inline-block"></i> BACK TO HOME
                </Link>
              </div>
              <div className="xl:col-span-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error403
